import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';

@Injectable({
  providedIn: 'root'
})
export class AssignedUserService {

  constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }
  getUserList(periodId): Observable<any> {

    return this.http
      .get(`${this.constantsService.baseAPIURL}/gikpi/getUserGroupIKPI/loadUserList/${periodId}`, this.constantsService.httpCustomOptions)
      .pipe(

        catchError(this.handleError)
      );
  }

  getGridData(periodId, tierId, round, dataArr): Observable<any> {

    const InData  = {
      P_PeriodID: periodId,
      P_TierID: parseInt(tierId),
      P_Round: round,
      P_UserList: dataArr
    }
    return this.http
      .post(`${this.constantsService.baseAPIURL}/gikpi/getUserGroupIKPI`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
      .pipe(

        catchError(this.handleError)
      );
  }
  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || "Server Error");
  }
}
